import React, { Component, useEffect } from "react";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { useTranslation } from 'react-i18next';
import { withTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DevicesIcon from "@material-ui/icons/Devices";
import PersonIcon from "@material-ui/icons/Person";
import { useHistory } from "react-router-dom";
import SvgIcon from "@material-ui/core/SvgIcon";
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import { connect } from "react-redux";
import { settemplateID } from "../redux/actions/appActions";

const ThemeSwitcher = (props) => {
  var tempid = props.templateID;
  let history = useHistory();
  const { switcher, themes, currentTheme, status } = useThemeSwitcher();
  const [isDarkMode, setIsDarkMode] = React.useState(false);
  const [collapseflag, setcollapseflag] = React.useState(false);
  const [value, setValue] = React.useState(tempid);
  const [listforlanguage, setlistforlanguage] = React.useState([{ id: 1, name: "Template1" }, { id: 2, name: "Template2" }])
  const [t] = useTranslation();

  useEffect(() => {
    if (value != props.chnageTheme) {
      setValue(props.chnageTheme)
      switcher({ theme: props.chnageTheme == 1 ? themes.template1 : (props.chnageTheme == 2 ? themes.template2 : themes.template3) });
      localStorage.setItem("templateID", props.chnageTheme);
      props.settemplateID(props.chnageTheme)
    }
  }, [props.chnageTheme]);

  const toggleDarkMode = (currentid) => {
    setIsDarkMode((previous) => {
      switcher({ theme: currentid == 1 ? themes.template1 : (currentid == 2 ? themes.template2 : themes.template3) });
      localStorage.setItem("templateID", currentid);
      return !previous;
    });
  };

  const handleChange = (e) => {
    console.log(e.target.value)
    setValue(parseInt(e.target.value));
    toggleDarkMode(parseInt(e.target.value))
    props.settemplateID(e.target.value)
  }


  const handleSubmenuClick = () => {
    setcollapseflag(!collapseflag);
  }

  return (
    <>
      {
        props.showcontent && (
          <>
            <ListItem button onClick={() => handleSubmenuClick()}>
              <ListItemIcon>
                 <i className="demo-icon icon-theme"></i>
              </ListItemIcon>
              <ListItemText primary={t('Switch theme')} />
              {collapseflag ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={collapseflag} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button>
                  <FormControl component="fieldset" key="1">
                    <RadioGroup name="temaple" value={value}>
                      {listforlanguage.length > 0 && listforlanguage.map((name) => (
                        <FormControlLabel
                          className="animate__animated animate__zoomIn animate__faster"
                          key={name.id}
                          value={name.id}
                          control={<Radio />}
                          label={t(name.name)}
                          onChange={handleChange}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </ListItem>
              </List>
            </Collapse>
          </>
        )
      }
    </>
  );
};



const mapStateToProps = state => {
  let { storeState } = state;
  console.log(state)
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
  };
}

export default connect(mapStateToProps, { settemplateID })(withTranslation()(ThemeSwitcher))
